import { Theming } from "@pandas/core-ui";
import type { Location, Partner, PartnerSettings } from "@pandas/http-client";
import type { StateCreator } from "zustand";
import { Storage } from "../index";

export type AppConfig = { theming: Theming; partnerSettings: PartnerSettings };

export type PartnerConfigSlice = {
	partnerName: string | null;
	language: string | null;
	config: AppConfig | null;
	configId: string | null;
	location: Location | null;
	partner: Partner | null;
	hasPickedLocation: boolean;
	setHasPickedLocation: (_hasPickedLocation: boolean) => void;
	setLocation: (_locationInfo: Location) => void;
	setPartner: (_partner: Partner) => void;
	setConfig: (_configId: string, _config: AppConfig) => void;
	clearPartnerData: () => void;
	clearHasPickedLocation: () => void;
	setLanguage: (_language: string) => void;
};

const partnerConfigInitialState: Omit<
	PartnerConfigSlice,
	| "setHasPickedLocation"
	| "setLocation"
	| "setPartner"
	| "setConfig"
	| "clearPartnerData"
	| "clearHasPickedLocation"
	| "setLanguage"
> = {
	partnerName: null,
	language: null,
	config: null,
	configId: null,
	location: null,
	partner: null,
	hasPickedLocation: false,
};

export const createPartnerConfigSlice: StateCreator<Storage, [], [], PartnerConfigSlice> = (set) => ({
	...partnerConfigInitialState,
	setHasPickedLocation: (hasPickedLocation) => set({ hasPickedLocation }),
	setLocation: (locationInfo: Location) =>
		set(() => ({
			location: locationInfo,
		})),
	setPartner: (partner: Partner) =>
		set(() => ({
			partner: partner,
		})),
	setConfig: (configId, config) => {
		set(() => ({
			configId: configId,
			config: config,
			paymentMethod: config.partnerSettings.paymentMethods[0],
		}));
	},
	clearPartnerData: () =>
		set(() => ({
			...partnerConfigInitialState,
		})),
	clearHasPickedLocation: () => set({ hasPickedLocation: false }),
	setLanguage: (language: string) =>
		set(() => ({
			language,
		})),
});
